import React from 'react';

interface FupNotProps {
  width?: number;
  height?: number;
}

const FupNot: React.FC<FupNotProps> = ({ width = 80, height = 60 }) => (
  <svg width={width} height={height} viewBox="0 0 80 60" xmlns="http://www.w3.org/2000/svg">
    {/* Dreieck */}
    <path d="M 10 15 L 10 45 L 60 30 Z" fill="#E8F4F8" stroke="#0D3559" strokeWidth="2" />
    
    {/* Negation-Kreis */}
    <circle cx="65" cy="30" r="5" fill="none" stroke="#0D3559" strokeWidth="2" />
    
    {/* Eingangs-Ankerpunkt */}
    <circle cx="5" cy="30" r="3" fill="#0D3559" />
    
    {/* Ausgangs-Ankerpunkt */}
    <circle cx="75" cy="30" r="3" fill="#0D3559" />
    
    {/* Label */}
    <text x="30" y="35" fontSize="14" fill="#0D3559" textAnchor="middle" fontWeight="bold">1</text>
  </svg>
);

export default FupNot;
